enum CallCenterCallDirection {
    Inbound = 0,
    Outbound = 1,
    ClickToDial = 2
}

export { CallCenterCallDirection };
